import MyData from "./FakeMyData";
import BillsFake from "@/components/Fakes/my-bills-fake";
import AllBillsFake from "@/components/Fakes/all-bills-fake";
import BillDetailsFake from "@/components/Fakes/detail-bill-fake";
import MainBreakDownPageFake from "./BreakDownsFakes/MainBreakDownPageFake";
import UsageDetailsFake from "./UsageDetailsFake";
import MyProductFake from "./my-products";
import ExtraUsageFake from "./ExtraUsageFake";
import SecureConnectionFake from "./SecureConnectionFake/SecureConnectionFake";
import SVAFake from "./SvaFake";
import DataManagementFake from "./DataManagementFake";
import DefaultFake from "./DefaultFake";
import MyDataFake from "@/components/Fakes/my-data";
import GeneralManagment from "@/components/Fakes/general-managment";
import UsagesFake from "@components/Fakes/UsagesFake";
import MenuFake from "@/components/Fakes/my-products/menu";
import UsagesDetailsFake from "@/components/Fakes/UsageDetailsFake";
import DevicesFake from "@/components/Fakes/devices-fake";
import FakeTvDetail from "@/components/Fakes/tv-detail";
import NewFakeTvDetail from "@/components/Fakes/new-tv-detail";
import AppointmentFake from "@/components/Fakes/my-data/appointment-fake"
import FakeProviderActivation from "@/components/Fakes/tv-detail/provider-activation";
import MytraceabilityFake from "@/components/Fakes/traceability";
import SmartWifiFake from "@/components/Fakes/smart-wifi-fake";
import TrackingFake from "@/components/Fakes/tracking-fake"
import ModalEsimFake  from  "@/components/Fakes/ModalEsimFake"
import SupportFake from "@/components/Fakes/support-fake"
import BillAddressFake from "@/components/Fakes/bill-address-fake";
import BillAddressSeacrhFake from "@/components/Fakes/bill-address-search";
import OnboardingHomeFake from "@/components/Fakes/onboarding/home";
import ContactMeanFake from "@/components/Fakes/onboarding/contact"; 
import MyConsentsFake from "@/components/Fakes/my-consents";
import MyConsentsDetailFake from "@/components/Fakes/my-consents/detail";
import CerberusFake from "@/components/Fakes/cerberus/main";
import CerberusReportFake from "@/components/Fakes/cerberus/report";
import EcoBillFake from "@/components/Fakes/eco-bill";

export const SectionContainerFakes = {
  DEFAULT: DefaultFake,
  MY_DATA: MyData,
  BILLS: BillsFake,
  BILLS_DETAILS: BillDetailsFake,
  ALL_BILLS: AllBillsFake,
  BREAKDOWN: MainBreakDownPageFake,
  MY_PRODUCTS: MyProductFake,
  MY_USAGES_DETAILS: UsageDetailsFake,
  EXTRA_USAGES: ExtraUsageFake,
  SECURE_CONNECTION: SecureConnectionFake,
  SVA: SVAFake,
  DATA_MANAGEMENT: DataManagementFake,
  MY_CONTRACTS: SecureConnectionFake,
  MY_DATA: MyDataFake,
  ALL_USAGE_FAKE: UsagesFake,
  USAGE_DETAILS_FAKE: UsagesDetailsFake,
  GENERAL_MANAGMENT: GeneralManagment,
  MENU: MenuFake,
  DEVICES: DevicesFake,
  TV_DETAIL: FakeTvDetail,
  NEW_TV_DETAIL: NewFakeTvDetail,
  APPOINTMENT: AppointmentFake, 
  PROVIDER_ACTIVATION: FakeProviderActivation,
  TRACEABILITY_FAKE:MytraceabilityFake,
  SMART_WIFI: SmartWifiFake,
  TRACKING: TrackingFake,
  MODALESIM:ModalEsimFake,
  SUPPORT: SupportFake,
  BILL_ADDRESS: BillAddressFake,
  BILL_ADDRESS_SEARCH: BillAddressSeacrhFake,
  ONBOARDING_HOME: OnboardingHomeFake,
  CONTACT_MEANS: ContactMeanFake,
  CONSENTS: MyConsentsFake,
  CONSENTS_DETAIL: MyConsentsDetailFake, 
  CERBERUS: CerberusFake,
  CERBERUS_REPORT: CerberusReportFake,
  ECO_BILL: EcoBillFake
};
